import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Geist, Geist_Mono, Pixelify_Sans } from 'next/font/google'

const geistSans = Geist({
    variable: '--font-sans',
    subsets: ['latin']
})

const geistMono = Geist_Mono({
    variable: '--font-geist-mono',
    subsets: ['latin']
})

/* The display face for everything inside the game world: headings, labels,
 * badges and buttons. Body copy stays on a clean sans for readability. */
const pixelifySans = Pixelify_Sans({
    variable: '--font-pixel',
    weight: ['400', '500', '600', '700'],
    subsets: ['latin'],
    display: 'swap'
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${geistSans.variable} ${geistMono.variable} ${pixelifySans.variable} h-full font-sans antialiased`}>
            <Component {...pageProps} />
        </div>
    )
}

export default App
